import * as types from '../actiontypes';

export function getAllActiveDataCenters(url) {
	return {
		type: types.GET_ALL_DAAS_WORKSPACES,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getWorkspacesDetails(url) {
	return {
		type: types.GET_ALL_DAAS_WORKSPACES_DETAILS,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'GET',
			}
		}
	};
}

export function addCollaborationSiteWorkspace(url, payload) {
	return {
		type: types.ADD_DAAS_WORKSPACE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		}
	};
}
